module.exports = __webpack_public_path__ + "static/media/gimlet.f0133eb5.svg";